export default __webpack_public_path__ + "static/media/immortalwrath.a3daf048.png";